export const SERVICE_KEYS = {
  API_INSTANCE: Symbol.for('API_INSTANCE'),
  BOOKING_REPOSITORY: Symbol.for('BOOKING_REPOSITORY'),
  APP_REPOSITORY: Symbol.for('APP_REPOSITORY'),
};
